<template>
<div class="item" @click="onPressNav('orderDetail', {order_id: item.id, order_no: item.order_no})">
    <div class="header">
        <p>{{item.company_name}}{{' '+item.pay_time}}</p>
        <span v-if="item.is_refund < 2" :class="(type===1||type===2||type===3)&&'blue'">{{item.status_text}}</span>
        <span v-else :class="(type===1||type===2||type===3)&&'blue'">{{item.refund_status_text}}</span>
    </div>
    <div class="body">
        <div v-for="(_item, _index) in item.order_detail" :key="_index">
            <img :src="_item.goods_image" alt="">
            <div>
                <p class="title">{{_item.goods_name}}</p>
                <p class="unit">规格:{{_item.sku_field_name}}</p>
                <div class="price">
                    <p>￥{{_item.payment}}</p>
                    <span>×{{_item.qty}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <p>合计:<span>￥<span>{{item.total_payment}}</span></span></p>
        <div class="btn1" v-if="item.status==='WAIT_BUYER_PAY'" @click.stop="onPressCancelOrder(item)">取消订单</div>
        <div class="btn2" v-if="item.status==='WAIT_BUYER_PAY'" @click="onPressNav('orderDetail', {order_id: item.id, order_no: item.order_no})">去付款</div>
        <template v-if="item.is_refund < 1">
            <div class="btn1" v-if="item.status==='TRADE_PAID'||item.status==='SEND_SOME_GOODS'||item.status==='WAIT_SELLER_SEND_GOODS'||item.status==='WAIT_BUYER_CONFIRM_GOODS'||item.status==='TRADE_SUCCESS'" @click.stop.stop="onPressNav('refund', {order_id: item.id, order_no: item.order_no})">售后</div>
            <div class="btn2" v-if="item.status==='WAIT_BUYER_CONFIRM_GOODS'" @click.stop="onPressReceive(item)">确认收货</div>
        </template>
        <template v-if="item.is_refund == 1">
            <div class="status-text">{{item.refund_status_text}}</div>
        </template>
    </div>
</div>
</template>

<script>
export default {
    name: "orderItem",
    props: ['item', 'type'],
    data() {
        return {

        };
    },
    methods: {
        onPressNav(router, query = {}) {
            this.$router.push({
                path: '/' + router,
                query: query
            })
        },
        // 取消订单
        onPressCancelOrder(item) {
            this.$dialog.confirm({
                    title: '温馨提示',
                    message: '您的操作即将取消订单！',
                })
                .then(() => {
                    this.cancelOrder(item);
                })
                .catch((error) => {
                    console.log('error---->', error);
                });
        },
        // 取消
        async cancelOrder(item) {
            let url = this.API.shop_cancel_order;
            let params = {order_no: item.order_no,
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: result.msg,
                });
                this.$emit("refresh")
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 点击收货
        onPressReceive(item) {
            this.$dialog.confirm({
                    title: '温馨提示',
                    message: '确认收到货物',
                })
                .then(() => {
                    this.receive(item);
                })
                .catch((error) => {
                    console.log('error---->', error);
                });
        },
        // 收货
        async receive(item) {
            let url = this.API.shop_receive_order;
            let params = {
                order_no: item.order_no,
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: result.msg,
                });
                this.$emit("refresh")
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.item {
    margin: 10px 15px;
    border-radius: 5px;
    background: #fff;

    .header {
        height: 40px;
        margin: 0 10px;
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #f3f0ee;

        p {
            flex: 1;
            font-size: 14px;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        span {
            font-size: 14px;
            color: #333;
            white-space: nowrap;
        }

        .blue {
            color: #7181EB;
        }
    }

    .body {
        padding: 0 10px 10px;

        >div {
            display: flex;
            margin: 10px 0 0;

            >img {
                width: 80px;
                height: 80px;
                object-fit: cover;
                margin-right: 10px;
            }

            >div {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                overflow: hidden;

                .title {
                    font-size: 14px;
                    color: #333;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }

                .unit {
                    font-size: 12px;
                    color: #666666;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .price {
                    display: flex;
                    align-items: center;

                    p {
                        flex: 1;
                        font-size: 14px;
                        color: #EF1400;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    span {
                        font-size: 13px;
                        color: #333;
                        white-space: nowrap;
                    }
                }
            }
        }
    }

    .footer {
        height: 45px;
        margin: 0 10px;
        border-top: 1px dashed #f3f0ee;
        display: flex;
        align-items: center;

        p {
            flex: 1;
            font-size: 14px;
            color: #333;
            line-height: 45px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            >span {
                color: #C9382C;

                >span {
                    font-size: 18px;
                }
            }
        }

        div {
            width: 62px;
            height: 26px;
            margin-left: 10px;
            border-radius: 3px;
            font-size: 13px;
            text-align: center;
            line-height: 26px;
        }

        .btn1 {
            width: 60px;
            height: 24px;
            border: 1px solid #7D8BEC;
            color: #7D8BEC;
            line-height: 24px;
        }

        .btn2 {
            background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
            color: #fff;
        }

        .status-text {
            width: auto;
            height: 24px;
            color: #7D8BEC;
            padding: 0 10px;
            line-height: 24px;            
            border: 1px solid #7D8BEC;
        }
    }
}
</style>
